<div class="d-flex justify-content-center">
    <a href="https://inwestycjewzloto.pl" target="_blank">
        <img class="w-100" src="/assets/images/banners/banner_6.jpg" alt="" />
    </a>
</div>
